<template>
  <div class="video-assign-component">
    <div class="form-group">
      <label for="type">Type</label>
      <select v-model="selectedType" class="form-control" name="type" id="type">
        <option :value="null">Select</option>
        <option v-for="type in types" :key="type" :value="type">
          {{ type }}
        </option>
      </select>
    </div>

    <div v-if="selectedType === 'Development'" class="form-group">
      <label for="development">Development</label>
      <select
        v-model="selectedDevelopment"
        class="form-control"
        name="development"
        id="development"
      >
        <option :value="null">Select</option>
        <option
          v-for="development in developments"
          :key="development.id"
          :value="development"
        >
          {{ development.name }}
        </option>
      </select>
    </div>

    <div
      v-if="selectedType === 'Development' && selectedDevelopment"
      class="form-group"
    >
      <label for="house_type">House Type</label>
      <select
        v-model="selectedHouseType"
        class="form-control"
        name="house_type"
        id="house_type"
      >
        <option :value="null">All</option>
        <option
          v-for="houseType in selectedDevelopment.house_types"
          :key="houseType.id"
          :value="houseType"
        >
          {{ houseType.name }}
        </option>
      </select>
    </div>

    <div v-if="selectedType === 'Development' && selectedDevelopment && selectedHouseType" class="form-group">
      <label for="plot">House</label>
      <select v-model="selectedPlot" class="form-control" name="plot" id="plot">
        <option :value="null">All</option>
        <option v-for="plot in selectedDevelopment.plots.filter(p => p.house_type_id === selectedHouseType.id)"
          :key="plot.id" :value="plot">
          {{ plot.name_number }}
        </option>
      </select>
    </div>

    <div v-if="selectedType === 'User'" class="form-group">
      <label for="user">User</label>
      <select v-model="selectedUser" class="form-control" name="user" id="user">
        <option :value="null">Select</option>
        <option v-for="user in users" :key="user.id" :value="user">
          {{ user.name }} - {{ user.email }}
        </option>
      </select>
    </div>

    <input v-model="videoableId" type="hidden" name="videoable_id" />
    <input v-model="videoableType" type="hidden" name="videoable_type" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      types: ["Development", "User"],
      selectedType: null,
      selectedDevelopment: null,
      selectedHouseType: null,
      selectedUser: null,
      videoableId: null,
      videoableType: null,
      selectedPlot: null,
    };
  },

  props: {
    video: {
      type: Object,
      default: null,
    },
    developments: {
      type: Array,
      default: null,
    },
    users: {
      type: Array,
      default: null,
    },
    preloadVideoableId: {
      type: Number,
      default: null,
    },
    preloadVideoableType: {
      type: String,
      default: null,
    },
    preloadVideoable: {
      type: Object,
      default: null,
    },
  },

  watch: {
    selectedType: function (newValue, oldValue) {
      this.selectedDevelopment = null;
      this.selectedHouseType = null;
      this.selectedPlot = null;
      this.selectedUser = null;

      this.videoableId = null;
      this.videoableType = null;
    },

    selectedDevelopment: function (newValue, oldValue) {
      this.selectedHouseType = null;
      this.selectedUser = null;

      if (newValue) {
        this.videoableId = newValue.id;
        this.videoableType = "App\\Models\\Development";
      } else {
        this.videoableId = null;
        this.videoableType = null;
      }
    },

    selectedHouseType: function (newValue, oldValue) {
      this.selectedUser = null;

      if (newValue) {
        this.videoableId = newValue.id;
        this.videoableType = "App\\Models\\DevelopmentHouseType";
      } else if (this.selectedDevelopment) {
        this.videoableId = this.selectedDevelopment.id;
        this.videoableType = "App\\Models\\Development";
      } else {
        this.videoableId = null;
        this.videoableType = null;
      }
    },

    selectedPlot: function (newValue, oldValue) {
      this.selectedUser = null;

      if (newValue) {
        this.videoableId = newValue.id;
        this.videoableType = "App\\Models\\Plot";
      } else if (this.selectedHouseType) {
        this.videoableId = this.selectedHouseType.id;
        this.videoableType = "App\\Models\\DevelopmentHouseType";
      } else if (this.selectedDevelopment) {
        this.videoableId = this.selectedDevelopment.id;
        this.videoableType = "App\\Models\\Development";
      } else {
        this.videoableId = null;
        this.videoableType = null;
      }
    },

    selectedUser: function (newValue, oldValue) {
      this.selectedDevelopment = null;
      this.selectedHouseType = null;

      if (newValue) {
        this.videoableId = newValue.id;
        this.videoableType = "App\\Models\\User";
      } else {
        this.videoableId = null;
        this.videoableType = null;
      }
    },
  },

  created() {
    if (this.preloadVideoableId !== null && this.preloadVideoableType) {
      if (this.preloadVideoableType === "App\\Models\\User") {
        this.selectedType = "User";

        this.$nextTick(() => {
          this.selectedUser = this.users.filter(
            (user) => user.id === this.preloadVideoableId
          )[0];
        });
      } else {
        if (this.preloadVideoable !== null) {
          this.selectedType = 'Development';

          // Plot?
          if (this.preloadVideoableType === 'App\\Models\\Plot') {
            this.preloadDevelopment().then(() => {
              this.preloadHouseType().then(() => {
                this.preloadPlot();
              });
            });
          }

          // House Type?
          if (this.preloadVideoableType === 'App\\Models\\DevelopmentHouseType') {
            this.preloadDevelopment().then(() => {
              this.preloadHouseType();
            });
          }

          // Development?
          if (this.preloadVideoableType === 'App\\Models\\Development') {
            this.preloadDevelopment();
          }
        }
      }
    }
  },

  methods: {
    preloadDevelopment() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          resolve(this.selectedDevelopment = this.developments.find(development => development.id === (this.preloadVideoable.development_id || this.preloadVideoableId)));
        });
      });
    },

    preloadHouseType() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          resolve(this.selectedHouseType = this.selectedDevelopment.house_types.find(houseType => houseType.id === (this.preloadVideoable.house_type_id || this.preloadVideoableId)));
        });
      });
    },

    preloadPlot() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          resolve(this.selectedPlot = this.selectedDevelopment.plots.find(plot => plot.id === this.preloadVideoable.id));
        });
      });
    },
  },
};
</script>
